import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import { handleDownloadCSV } from "../../../../utils/CsvDownload";

const Table = ({ setselected_item_data, list_data, allitems }) => {
  const createNewRow = () => ({
    item_code: "",
    item: {},
    required_by: "",
    quantity: "1",
    uom: "",
    rate: "0",
    amount: "0",
  });
  const status = 'Draf'
  const tableRef = useRef();
  const dropdownRef = useRef();
  const [offset, setOffset] = useState(0);
  const [item_list, setitem_list] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [search_input, setsearch_input] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
  const [rowsPerPage] = useState(10);
  // console.log("all selected",allitems,"alll items coming form api",item_list,"rows( showing itens) ",rows)
  // Initialize rows with allitems data when component mounts or allitems changes
  useEffect(() => {
    if (allitems && allitems.length > 0) {
      const mappedRows = allitems.map(item => ({
        item_code: item.item_code,
        item: {
          item_code: item.item_code,
          item_name: item.item_name,
          stock_uom: item.stock_uom,
          buying_price: item.rate,
          item_group:item.item_group,
          custom_category:item.custom_category

        },
        quantity: item.qty,
        uom: item.stock_uom,
        rate: item.rate,
        amount: item.base_amount
      }));
      setRows(mappedRows);
      setselected_item_data(mappedRows);
    } else {
      // If no allitems, start with one empty row
      setRows([createNewRow()]);
    }
  }, [allitems]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allRowIndices = rows.map((_, index) => index);
      setSelectedRows(allRowIndices);
    } else {
      setSelectedRows([]);
    }
  };

  const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);

  const getItemdata = async (newOffset = 0, searchText = "") => {
    const res = await list_data({ start: newOffset, search_input: searchText });
    // console.log("check response of list data",res);
    const products = res?.data?.result?.products || [];
    if (newOffset === 0) {
      setitem_list(products);
    } else {
      setitem_list((prev) => [...prev, ...products]);
    }
    setHasMore(products.length === 20);
  };

  const updateRow = (index, field, value) => {
    // console.log("check value data and fields",value,field)
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    // console.log("check update",updatedRows)
    setRows(updatedRows);
    setselected_item_data(updatedRows);
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleAddRow = () => {
    const newRows = [...rows, createNewRow()];
    setRows(newRows);
    setselected_item_data(newRows);
    const lastPage = Math.ceil(newRows.length / rowsPerPage);
    if (currentPage !== lastPage) {
      setCurrentPage(lastPage);
    }
  };

  const handleDeleteSelectedRows = () => {
    const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
    setRows(updatedRows);
    setselected_item_data(updatedRows);
    setSelectedRows([]);
    const lastPage = Math.ceil(updatedRows.length / rowsPerPage);

    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  };

  useEffect(() => {
    getItemdata(0, "");
  }, []);

  useEffect(() => {
    const dropdown = dropdownRef.current;
    if (!dropdown) return;
    const handleScroll = () => {
      if (dropdown.scrollTop + dropdown.clientHeight >= dropdown.scrollHeight - 10 && hasMore) {
        const newOffset = offset + 20;
        setOffset(newOffset);
        getItemdata(newOffset, search_input);
      }
    };
    dropdown.addEventListener("scroll", handleScroll);
    return () => dropdown.removeEventListener("scroll", handleScroll);
  }, [offset, hasMore, search_input]);

  useEffect(() => {
    const cols = tableRef.current.querySelectorAll("th");
    cols.forEach((col) => {
      const resizer = document.createElement("div");
      resizer.className = "resizer";
      col.appendChild(resizer);

      let x = 0;
      let w = 0;

      const onMouseDown = (e) => {
        x = e.clientX;
        w = col.offsetWidth;

        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
      };

      const onMouseMove = (e) => {
        const dx = e.clientX - x;
        col.style.width = `${w + dx}px`;
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      resizer.addEventListener("mousedown", onMouseDown);
    });
  }, []);

  return (
    <div className="">
      <style>
        {`
          .resizer {
            position: absolute;
            top: 0;
            right: 0;
            width: 5px;
            height: 100%;
            background: rgba(0, 0, 0, 0.1);
            cursor: col-resize;
            user-select: none;
            touch-action: none;
          }
          
          .resizer:hover,
          .resizer:active {
            background: #ff8d5c;
          }
          
          th {
            position: relative;
          }
          
          .table {
            table-layout: fixed;
            width: 100%;
          }
          
          .tableHead1 th {
            background-color: #f8f9fa;
            font-weight: 600;
          }

          .pagination-container {
            display: flex;
            justify-content: flex-end;
            margin-top: 1rem;
          }
        `}
      </style>
      <table className="table table-bordered mb-1" ref={tableRef}>
        <thead className="tableHead1">
          <tr>
            {[ "S.No", "Item Code", "Item Name","Category" ,"Sub Category" , "Quantity", "UOM", "Rate", "Amount"].map((title, i) => {
              const defaultWidths = {
              //  "Action": "20px",
                "S.No": "20px",
                "Item Code": "15%",
                "Item Name": "15%",
                "Category": "15%",
                "Sub Category":"15%",
                "Quantity": "7%",
                "UOM": "6%",
                "Rate": "10%",
                "Amount": "10%",
              };

              return (
                <th
                  key={i}
                  style={{
                    fontSize: '7px',
                    position: "relative",
                    textAlign: title === "Action" || title === "S.No" ? "center" : "center",
                    width: defaultWidths[title] || "150px",
                    minWidth: defaultWidths[title] || "150px",
                  }}
                >
                  {title === "Action" ? (
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ backgroundColor: isAllSelected ? "#270b79" : "", borderColor: isAllSelected ? "#270b79" : "", fontSize: '15px' }}
                      checked={isAllSelected}
                      onChange={handleSelectAll}
                    />
                  ) : (
                    title
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {currentRows.map((row, index) => {
            const globalIndex = indexOfFirstRow + index;
            return (
              <tr key={globalIndex}>
                <td style={{
                  textAlign: "center",
                  fontSize: '0.8rem',
                  padding: '0.5rem'
                }}>
                  {globalIndex + 1}
                </td>

                <td className="p-0" style={{ position: "relative", border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'item_code' ? '0.3px solid #270b79' : '' }}>
                  <input
                    type="text"
                    className="form-control tableinput noborder"
                    style={{
                      fontSize: '0.8rem', backgroundColor: status !== 'Draft' ? 'white' : undefined,
                      color: status !== 'Draft' ? 'black' : undefined,
                      textAlign:'center'
                    }}
                    onFocus={() => { setShowDropdown(globalIndex); setFocusedCell({ rowIndex: globalIndex, field: 'item_code' }) }}
                    onBlur={() => { setTimeout(() => setShowDropdown(false), 300); setFocusedCell({ rowIndex: null, field: null }) }}
                    disabled={status !== 'Draft'}
                    onChange={(e) => {
                      setsearch_input(e.target.value);
                      setOffset(0);
                      getItemdata(0, e.target.value);
                      updateRow(globalIndex, "item_code", e.target.value);
                    }}
                    value={row.item.item_code || row.item_code}
                  />

                  <div
                    ref={dropdownRef}
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      maxHeight: showDropdown === globalIndex ? "200px" : "0",
                      display: showDropdown === globalIndex ? '' : 'none',
                      overflowY: "auto",
                      background: "white",
                      border: showDropdown === globalIndex ? "1px solid #ccc" : "",
                      zIndex: 10,
                    }}
                  >
                    {item_list.map((item, idx) => (
                      <div key={idx}
                        className="text-start"
                        onClick={() => {
                          updateRow(globalIndex, "item", item);
                          updateRow(globalIndex, "item_code", item.item_code);
                          setsearch_input("");
                          setShowDropdown(false);
                        }}
                        style={{
                          padding: "8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        <p className="m-0" >
                          {item.item_code}
                        </p>
                        <div style={{ fontSize: '10px' }}>
                          {item?.item_name}, {item?.item_group}
                        </div>
                      </div>
                    ))}
                    {!hasMore && item_list.length === 0 && (
                      <div style={{ padding: "8px", color: "#888" }}>No results</div>
                    )}
                  </div>
                </td>
                <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem',textAlign:'center' }} readOnly value={row.item.item_name} /></td>
                {/* Item Category */}
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={row?.item?.custom_category || ""} />
                </td>
                {/* Item Sub category */}
                <td className="p-0">
                  <input
                    type="text"
                    className=" p-0 form-control tableinput noborder"
                    style={{ fontSize: '0.8rem', textAlign: 'center', lineHeight: '29px' }}
                    readOnly
                    value={ row?.item?.item_group || ""} />
                </td>
                <td className="p-0" style={{ border: focusedCell.rowIndex === globalIndex && focusedCell.field === 'quantity' ? '0.3px solid #270b79' : '' }}>
                  <input type="number" className="form-control tableinput noborder" style={{
                  fontSize: '0.8rem',
                  textAlign:'center',
                  backgroundColor: status !== 'Draft' ? 'white' : undefined,
                  color: status !== 'Draft' ? 'black' : undefined,
                }}
                  onFocus={() => setFocusedCell({ rowIndex: globalIndex, field: 'quantity' })}
                  disabled={status !== 'Draft'} min={1}
                  onBlur={() => setFocusedCell({ rowIndex: null, field: null })}
                  value={row.quantity} onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (value >= 1 || e.target.value === '') {
                      updateRow(globalIndex, "quantity", e.target.value);
                    }
                  }} /></td>
                <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem',textAlign:'center' }} readOnly value={row.item.stock_uom || row.uom} /></td>
                <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem',textAlign:'center' }} readOnly value={row.item.buying_price ? `₹${row.item.buying_price}` : ''} /></td>
                <td className="p-0"><input type="text" className="form-control tableinput noborder" style={{ fontSize: '0.8rem',textAlign:'center' }} readOnly value={row.amount ? `₹${row.item.buying_price * row.quantity}` : ''} /></td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="d-flex pb-2 justify-content-between align-items-center">
        <div className="d-flex" style={{ gap: '4px' }}>
          

          
          <Button
            className="createbtn d-flex"
            style={{ gap: '2px', height: '28px' }}
            iconName="MdOutlineFileDownload"
            iconSize={12}
            onClick={()=>{handleDownloadCSV(["S.No", "Item Code", "Item Name", "Quantity", "UOM", "Rate", "Amount"],allitems)}}
            
          >
            Download
          </Button>
        </div>
        <div className={`${rows.length < 11 ? "d-none" : "d-flex"} align-items-center centerpagination`} style={{ gap: '5px' }}>
          <Pagination
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            pageSize={rowsPerPage}
            totalrecords={rows.length}
          />
        </div>
        <div className={`${rows.length < 11 ? "d-none" : "d-flex"}`}>
          <span className="px-2" style={{ fontSize: '12px', color: '#270B79' }}>
            Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
          </span>
        </div>
      </div>
    </div>
  );
};
export default Table;